<span
  *ngIf="active"
  class="app-item-pending-indicator"
  [class.app-item-pending-indicator--compact]="compact"
  [attr.aria-label]="ariaLabel"
  aria-live="polite"
>
  <mat-spinner [diameter]="diameter" aria-hidden="true"></mat-spinner>
  <span *ngIf="!compact" class="app-item-pending-indicator__label">{{
    label
  }}</span>
</span>
